import { useCallback } from 'react'

import {
  GetProductsBySkusParams,
  QUERY_DATA,
  getProductsBySkusService,
  useQueryClient,
} from 'src/service'

import { useMagazineContext } from '../useMagazineContext'
import { useResellerContext } from '../useResellerContext'
import { ResellerContextProps } from 'src/components/molecules/ResellerProvider'

export const createProductsBySkusQuery = ({
  skus,
  isGenericUser,
  reseller,
  magazine,
}: GetProductsBySkusParams) => ({
  queryKey: [QUERY_DATA.PRODUCT_BY_SKU, skus],
  queryFn: () => getProductsBySkusService({ skus, isGenericUser, reseller, magazine }),
  staleTime: Infinity,
})

/**
 * @requires QueryClientProvider
 */
export function useGetProductsBySkus() {
  const queryClient = useQueryClient()
  const magazine = useMagazineContext()
  const { reseller, isGenericUser } = useResellerContext() as ResellerContextProps

  return useCallback(
    (skus: string[]) =>
      queryClient.fetchQuery(
        createProductsBySkusQuery({ skus, isGenericUser, reseller, magazine }),
      ),
    [isGenericUser, magazine, queryClient, reseller],
  )
}
